/**
 * Ticket Source: Who initiated the ticket
 */
export const TicketSource = {
  PARTICIPANT_REQUEST: 'PARTICIPANT_REQUEST',
  PROVIDER_REQUEST: 'PROVIDER_REQUEST',
} as const;

/**
 * Support Type: Who provides the support
 */
export const TicketResponsibility = {
  PROVIDER_SUPPORT: 'PROVIDER_SUPPORT',
  ADMIN_SUPPORT: 'ADMIN_SUPPORT',
} as const;

/**
 * Support Domains: What type of support
 */
export const SupportDomain = {
  GENERAL: 'GENERAL',
  ASSESSMENT: 'ASSESSMENT',
  LEARNING: 'LEARNING',
  CASELOAD: 'CASELOAD',
} as const;

type TicketSource = (typeof TicketSource)[keyof typeof TicketSource];
type TicketResponsibility = (typeof TicketResponsibility)[keyof typeof TicketResponsibility];
type SupportDomain = (typeof SupportDomain)[keyof typeof SupportDomain];

export type TicketTag = TicketSource | TicketResponsibility | SupportDomain;
